export default {
  navigation: {
    next: "التالي",
    back: "السابق",
    surveyNavigation: "التنقل في الاستبيان",
    workspace: {
      home: "الرئيسية",
      example: "مثال"
    }
  }
}
